import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import ShopByCategoryPage from './components/ShopByCategoryPage';
import CategoryProductListPage from './components/CategoryProductListPage';
import BrandProductListPage from './components/BrandProductListPage';
import CartPage from './components/CartPage';
import CheckoutPage from './components/CheckoutPage';
import ProductDetailPage from './components/ProductDetailPage';
import AddProductPage from './components/AddProductPage';
import AdminProductsPage from './components/AdminProductsPage';
import AddSellerPage from './components/AddSellerPage';
import ManageSellersPage from './components/ManageSellersPage';
import ManageCustomersPage from './components/ManageCustomersPage';
import ProductOrderedReport from './components/ProductOrderedReport';
import LoginPage from './components/LoginPage';
import RegistrationPage from './components/RegistrationPage';
import ForgotPasswordPage from './components/ForgotPasswordPage';
import ResetPasswordPage from './components/ResetPasswordPage';
import ProfilePage from './components/ProfilePage';
import AdminKycPage from './components/AdminKycPage';
import OrderHistoryPage from './components/OrderHistoryPage';
import MyNetworkPage from './components/MyNetworkPage';
import SellerOrdersPage from './components/SellerOrdersPage';
import SellerCommissionPage from './components/SellerCommissionPage';
import MyPointsPage from './components/MyPointsPage';
import MyWalletPage from './components/MyWalletPage';
import AdminPointsReportPage from './components/AdminPointsReportPage';
import AdminCommissionReportPage from './components/AdminCommissionReportPage';
import AdminOfflineTransactionsPage from './components/AdminOfflineTransactionsPage';
import AdminPointsBenefitsPage from './components/AdminPointsBenefitsPage';
import AdminCategoriesPage from './components/AdminCategoriesPage';
import AdminAttributesPage from './components/AdminAttributesPage';
import OfflinePurchasePage from './components/OfflinePurchasePage';
import OfflineSalePage from './components/OfflineSalePage';
import SellerOfflineApprovalsPage from './components/SellerOfflineApprovalsPage';
import SellersInAreaPage from './components/SellersInAreaPage';
import InfoPage from './components/InfoPage';
import { FooterInfoProvider } from './components/FooterInfoContext';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function App() {
  return (
    <Router>
      <FooterInfoProvider>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<ShopByCategoryPage />} />
          <Route path="/category/:categoryId" element={<CategoryProductListPage />} />
          <Route path="/brand/:brandName" element={<BrandProductListPage />} />
          <Route path="/sellers-in-area" element={<SellersInAreaPage />} />
          <Route path="/about" element={<InfoPage pageKey="about" />} />
          <Route path="/contact" element={<InfoPage pageKey="contact" />} />
          <Route path="/careers" element={<InfoPage pageKey="careers" />} />
          <Route path="/stories" element={<InfoPage pageKey="stories" />} />
          <Route path="/press" element={<InfoPage pageKey="press" />} />
          <Route path="/corporate" element={<InfoPage pageKey="corporate" />} />
          <Route path="/payments" element={<InfoPage pageKey="payments" />} />
          <Route path="/shipping" element={<InfoPage pageKey="shipping" />} />
          <Route path="/cancellation" element={<InfoPage pageKey="cancellation" />} />
          <Route path="/terms" element={<InfoPage pageKey="terms" />} />
          <Route path="/security" element={<InfoPage pageKey="security" />} />
          <Route path="/privacy" element={<InfoPage pageKey="privacy" />} />
          <Route path="/sitemap" element={<InfoPage pageKey="sitemap" />} />
          <Route path="/grievance" element={<InfoPage pageKey="grievance" />} />
          <Route path="/epr" element={<InfoPage pageKey="epr" />} />
          <Route path="/faq" element={<InfoPage pageKey="faq" />} />
          <Route path="/product/:id" element={<ProductDetailPage />} />
          <Route path="/add-product" element={<AddProductPage />} />
          <Route path="/admin/products" element={<AdminProductsPage />} />
          <Route path="/admin/products/:productId/edit" element={<AdminProductsPage />} />
          <Route path="/admin/add-seller" element={<AddSellerPage />} />
          <Route path="/admin/sellers" element={<ManageSellersPage />} />
          <Route path="/admin/customers" element={<ManageCustomersPage />} />
          <Route path="/admin/reports/orders" element={<ProductOrderedReport />} />
          <Route path="/admin/kyc" element={<AdminKycPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/my-orders" element={<OrderHistoryPage />} />
          <Route path="/my-network" element={<MyNetworkPage />} />
          <Route path="/my-points" element={<MyPointsPage />} />
          <Route path="/my-wallet" element={<MyWalletPage />} />
          <Route path="/seller/orders" element={<SellerOrdersPage />} />
          <Route path="/seller/commission" element={<SellerCommissionPage />} />
          <Route path="/admin/reports/points" element={<AdminPointsReportPage />} />
          <Route path="/admin/points-benefits" element={<AdminPointsBenefitsPage />} />
          <Route path="/admin/categories" element={<AdminCategoriesPage />} />
          <Route path="/admin/attributes" element={<AdminAttributesPage />} />
          <Route path="/admin/reports/commission" element={<AdminCommissionReportPage />} />
          <Route path="/admin/offline-transactions" element={<AdminOfflineTransactionsPage />} />
          <Route path="/offline-purchase" element={<OfflinePurchasePage />} />
          <Route path="/seller/offline-sale" element={<OfflineSalePage />} />
          <Route path="/seller/offline-approvals" element={<SellerOfflineApprovalsPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route element={<ProtectedRoute />}> {/* Protected Routes go here */}
            <Route path="/checkout" element={<CheckoutPage />} />
          </Route>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegistrationPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
        </Routes>
      </div>
      </FooterInfoProvider>
    </Router>
  );
}

export default App;
